import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes with clsx
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * Trigger confetti animation on success
 * Reduced intensity to avoid overdoing it
 */
export async function celebrateSuccess() {
  const confetti = (await import('canvas-confetti')).default
  
  confetti({
    particleCount: 50,  // Reduced from 100
    spread: 60,         // Reduced from 70
    origin: { y: 0.6 },
    colors: ['#E61E8C', '#00ADEF', '#C8E632'],
    ticks: 150          // Shorter duration
  })
}

/**
 * Trigger shake animation on error
 */
export function shakeElement(elementRef) {
  if (elementRef.current) {
    elementRef.current.classList.add('shake')
    setTimeout(() => {
      elementRef.current?.classList.remove('shake')
    }, 400)
  }
}

/**
 * Save to localStorage with error handling
 */
export function saveToLocal(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data))
    return true
  } catch (error) {
    console.error('Failed to save to localStorage:', error)
    return false
  }
}

/**
 * Load from localStorage with error handling
 */
export function loadFromLocal(key) {
  try {
    const data = localStorage.getItem(key)
    return data ? JSON.parse(data) : null
  } catch (error) {
    console.error('Failed to load from localStorage:', error)
    return null
  }
}
